module.exports = __webpack_public_path__ + "img/elephant-art.a162d126.jpeg";